<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a>Images of War</h1>
<h1 class="title1"><span class="bold">GREAT WAR FIGHTER ACES 1914-1916</span></h1>
<p class="author"><span class="bold">Norman Franks</span></p>
<div class="image_containerf">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2928f84c